import React from 'react';
import { Instagram, Linkedin, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-blue-900 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-400">Fernando Meslin</h3>
            <p className="text-gray-300 text-sm">
              Profissional com experiência em rotinas administrativas e financeiras,
              focado em resultados e comprometido com a excelência.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-400">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-300 hover:text-yellow-400 transition-colors text-sm">
                  Início
                </a>
              </li>
              <li>
                <a href="/sobre" className="text-gray-300 hover:text-yellow-400 transition-colors text-sm">
                  Sobre
                </a>
              </li>
              <li>
                <a href="/curriculo" className="text-gray-300 hover:text-yellow-400 transition-colors text-sm">
                  Currículo
                </a>
              </li>
              <li>
                <a href="/fe" className="text-gray-300 hover:text-yellow-400 transition-colors text-sm">
                  Fé
                </a>
              </li>
              <li>
                <a href="/contato" className="text-gray-300 hover:text-yellow-400 transition-colors text-sm">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-400">Contato</h3>
            <div className="space-y-3">
              <a
                href="mailto:fernandomeslin@gmail.com"
                data-testid="footer-email"
                className="flex items-center space-x-2 text-gray-300 hover:text-yellow-400 transition-colors text-sm"
              >
                <Mail size={16} />
                <span>fernandomeslin@gmail.com</span>
              </a>
              <a
                href="tel:+5521991508223"
                data-testid="footer-phone"
                className="flex items-center space-x-2 text-gray-300 hover:text-yellow-400 transition-colors text-sm"
              >
                <Phone size={16} />
                <span>(21) 99150-8223</span>
              </a>
              <div className="flex space-x-4 mt-4">
                <a
                  href="https://www.instagram.com/fmeslin"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="text-gray-300 hover:text-yellow-400 transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram size={24} />
                </a>
                <a
                  href="https://www.linkedin.com/in/fernandomeslin"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin"
                  className="text-gray-300 hover:text-yellow-400 transition-colors"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={24} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-blue-800 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Fernando Meslin. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;